import { ConfirmLogoutModalView } from 'containers/common/confirmLogoutModal/ConfirmLogoutModalView'
import React from 'react'

interface Props {
  isConfirmationLogoutModalOpen: boolean
  setIsConfirmationLogoutModalOpen: (isOpen: boolean) => void
  setIsWelcomeModalOpen: (isOpen: boolean) => void
  handleShowCreateAccountForm: () => void
}

export const useConfirmLogoutModal = ({
  isConfirmationLogoutModalOpen,
  setIsConfirmationLogoutModalOpen,
  setIsWelcomeModalOpen,
  handleShowCreateAccountForm,
}: Props) => {
  const handleCancelLogout = () => {
    setIsConfirmationLogoutModalOpen(false)
    setIsWelcomeModalOpen(true)
  }

  const handleConfirmLogout = () => {
    setIsConfirmationLogoutModalOpen(false)
    handleShowCreateAccountForm()
  }

  return {
    ConfirmationLogoutModal: isConfirmationLogoutModalOpen ? (
      <ConfirmLogoutModalView
        isConfirmationLogoutModalOpen={isConfirmationLogoutModalOpen}
        handleConfirmLogout={handleConfirmLogout}
        handleCancelLogout={handleCancelLogout}
      />
    ) : null,
  }
}
